export default {
  example: {
    url: '/permission/reset_password',
    isMock: false,
    tips: '修改密码',
  },
}
